import { TReduxActions } from '../../../types/redux';
import { EStepActionTypes } from '../../../actions/newAnswer';
import { ENewAnswerModalStep } from '../../../types/newAnswer';

export const defaultValue = ENewAnswerModalStep.Answer;

export function stepReducer(
  state: ENewAnswerModalStep = defaultValue,
  { type, payload }: TReduxActions,
): ENewAnswerModalStep {
  if (type === EStepActionTypes.Set) {
    return payload;
  }

  return state;
}
